<template>
    <div class="t-page_termService t-work-area">
        <h1>{{ pageText.title }}</h1>
        <div v-if="terms_service.length > 0" class="t-work-area__row">
            <div class="t-work-area__column_small" v-if="!mobileState">
                <div class="t-work-area__cell t-faqMenu" v-stick-in-parent="stikyKit" id="terms_serviceMenu">
                    <div class="t-faqMenu__item" v-for="(item, index) in terms_service" :key="index">
                        <router-link :to="{name: 'terms_service', query: {question: 'terms_service_' + item.id}}"
                                     class="t-faqMenu__link t-faqMenu__link_big"
                                     :class="{'_active': 'terms_service_' + item.id === terms_service_active}"
                                     :data-id="'terms_service_' + item.id">{{ item.title }}</router-link>
                        <div>
                            <router-link v-for="(child, index_child) in item.child"
                                         :key="index_child"
                                         :to="{name: 'terms_service', query: {question: 'terms_service_child_' + child.id}}"
                                         class="t-faqMenu__link"
                                         :class="{'_active': 'terms_service_child_' + child.id === terms_service_active}"
                                         :data-id="'terms_service_child_' + child.id">{{ child.name }}</router-link>
                        </div>
                    </div>
                    <span class="t-faqMenu__active" :style="{top: top + 'px'}"></span>
                </div>
            </div>
            <div class="t-work-area__column_big">
                <div class="t-work-area__cell t-faqBox js-box" :data-id="'terms_service_' + item.id" v-for="(item, index) in terms_service" :key="index">
                    <h2>{{ item.title }}</h2>
                    <div class="t-faqBox__item js-box" :data-id="'terms_service_child_' + child.id"  v-for="(child, index_child) in item.child" :key="index_child">
                        <h3 @click.prevent="Open(index + '_' + index_child)" :class="{_open: open === index + '_' + index_child}">{{ child.name }}</h3>
                        <div v-html="child.text" class="t-default" v-if="!mobileState || open === index + '_' + index_child"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  let localeText = {
    url: process.env.NODE_ENV !== 'production' ? 'staticText/termService.json' : 'staticText',
    main: {
      title: "Правила сервиса"
    }
  };

  import { store } from '../../store'
  import {mapGetters} from 'vuex';
  import {mapActions} from 'vuex';

  export default {
      data(){
          return{
              pageText: {},

              stikyKit: {
                  options: {
                      offset_top: 114
                  }
              },
              open: -1
          }
      },
      computed: {
          ...mapGetters('terms_service', ['terms_service', 'terms_service_active', 'top']),
          ...mapGetters(['mobileState'])
      },
      methods: {
          ...mapActions(['UpdatePreloadState']),
          ...mapActions('terms_service', ['scrollTo']),
          Open(i){
              if(this.mobileState){
                  this.open = (this.open === i) ? -1 : i
              }
          },
          Load(pageText, query){
              this.pageText = pageText;
              setTimeout(() => {
                  this.UpdatePreloadState(false);

                  if (query) {
                      this.scrollTo(query);
                  }
              }, 500);
          }
      },
      beforeRouteLeave (to, from, next) {
          this.UpdatePreloadState(true);
          next();
      },
      beforeRouteUpdate(to, from, next) {
          this.scrollTo(to.query.question);
          next();
      },
      beforeRouteEnter (to, from, next) {
          let active = Object.keys(to.query).length ? to.query.question : 0;

          let count = 0;
          let pageText = {};

          store.dispatch('staticText/LoadPageText', localeText).then((data) => {
              pageText = data;

              count++;
              RunNext();
          });
          store.dispatch('terms_service/LoadTerms_service', active).then(() => {
              count++;
              RunNext();
          });
          let RunNext = () => {
              if(count > 1)
                  next(vm => vm.Load(pageText, to.query.question))
          }
      }
  }
</script>
<style lang="sass">
    //.t-page_termService.t-work-area
        //a
            //color: #52a8f2
</style>


// WEBPACK FOOTER //
// src/vue_pages/TermsService/Index.vue